import { pprops } from '@frontend/sports/common/core/utils/redux';
import { createAction } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';
import { IBetslipNotification } from '../validation/errors/betslip-notification';

export class BetslipNotificationActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/notification`;

    private static readonly SET_MESSAGE = `${BetslipNotificationActions.ACTION_SCHEMA}/SET_MESSAGE`;
    private static readonly CLEAR_MESSAGE = `${BetslipNotificationActions.ACTION_SCHEMA}/CLEAR_MESSAGE`;

    /* Set notification message in the betslip */
    static setMessage = createAction(BetslipNotificationActions.SET_MESSAGE, pprops<IBetslipNotification>());

    /* Clear notification message in the betslip */
    static clearMessage = createAction(BetslipNotificationActions.CLEAR_MESSAGE);
}
